var exports = {
  "UT": "gridContainer__AIEYjN",
  "UQ": "nameCell__7AqVxc",
  "jg": "nameCellNotFirst__GbXRsu",
  "fh": "nameText__vQ6q0J",
  "S7": "valueCell__MzdK7f",
  "M$": "valueCellFirst__xkciwI",
  "LO": "valueCellEnd__eam7ga",
  "Ru": "valueText__fqWLWg",
};

module.exports = exports;
